/**
 * Helper function to add DARB logo to PDF documents
 * Places logo top-left so it does not overlap right-side header text (DATE / INVOICE #).
 */
export const addLogoToPDF = async (
  doc: any,
  options?: { x?: number; y?: number; width?: number }
): Promise<boolean> => {
  return new Promise((resolve) => {
    try {
      const logoImg = new Image();
      logoImg.crossOrigin = 'anonymous';
      logoImg.src = '/cropped-pixelcut-export-removebg-2048x691.png';

      logoImg.onload = () => {
        try {
          const logoWidth = options?.width ?? 50;
          const logoHeight = (logoImg.height / logoImg.width) * logoWidth;
          const logoX = options?.x ?? 20;
          const logoY = options?.y ?? 10;
          doc.addImage(logoImg, 'PNG', logoX, logoY, logoWidth, logoHeight);
          resolve(true);
        } catch (error) {
          console.error('Error adding logo to PDF:', error);
          resolve(false);
        }
      };

      logoImg.onerror = () => {
        console.error('Error loading logo for PDF');
        resolve(false);
      };

      // Timeout after 3 seconds
      setTimeout(() => resolve(false), 3000);
    } catch (error) {
      console.error('Error processing logo for PDF:', error);
      resolve(false);
    }
  });
};
